'use client';

import PropTypes from 'prop-types';
import styles from './tabs.module.scss';
import { useRef } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';
import ScreenReaderOnly from 'components/accesibility/screen-reader-only';

const Tabs = ({
	smallTabs,
	handleTabChange,
	tabNames,
	activeTab,
	inputGroupName,
	screenreaderLegendText,
	tabNameAlignment = 'start',
	orientation = 'horizontal',
}) => {
	const ref = useRef(null);
	const { events } = useDraggable(ref);

	const isChecked = (category) =>
		category.toLowerCase() === activeTab.toLowerCase();

	const wrapperClasses = [styles.wrapper];
	if (orientation === 'vertical') {
		wrapperClasses.push(styles.vertical);
	}

	const labelClasses = [styles.label];
	if (smallTabs) {
		labelClasses.push(styles.small);
	}

	const fieldsetClasses = [styles.fieldset];
	if (tabNameAlignment !== 'start') {
		fieldsetClasses.push(styles[tabNameAlignment]);
	}

	return (
		<div className={wrapperClasses.join(' ')} {...events} ref={ref}>
			<fieldset className={fieldsetClasses.join(' ')}>
				<ScreenReaderOnly Element={'legend'} text={screenreaderLegendText} />
				{tabNames.map((tabName) => {
					return (
						<div className={styles.tab} key={tabName}>
							<input
								type="radio"
								id={`${tabName}-tab-id`}
								name={inputGroupName}
								value={tabName}
								className={styles.input}
								checked={isChecked(tabName)}
								onChange={handleTabChange}
							/>
							<label
								htmlFor={`${tabName}-tab-id`}
								className={labelClasses.join(' ')}
							>
								<div className={styles.tabText}>{tabName}</div>
							</label>
						</div>
					);
				})}
			</fieldset>
		</div>
	);
};

Tabs.propTypes = {
	activeTab: PropTypes.string.isRequired,
	handleTabChange: PropTypes.func.isRequired,
	inputGroupName: PropTypes.string.isRequired,
	screenreaderLegendText: PropTypes.string.isRequired,
	smallTabs: PropTypes.bool,
	tabNames: PropTypes.arrayOf(PropTypes.string).isRequired,
	tabNameAlignment: PropTypes.oneOf(['start', 'center', 'end']),
	orientation: PropTypes.oneOf(['horizontal', 'vertical']),
};

export default Tabs;
